export  function isExternal (path) {
    return /^(https?:)/.test(path)
}



// WEBPACK FOOTER //
// ./src/utils/validate.js